import React, { FC, AnchorHTMLAttributes } from 'react';
import './DefaultLink.css';

const DefaultLink: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ 
	className, 
	href, 
	...rest 
}): JSX.Element => {

	//Added timeout to help animations finish in safari
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
		e.preventDefault();
		setTimeout(() => {
			window.location.href = href ?? '';
		}, 250);
	};

	return (<a className={`DefaultLink no-underline min-w-full ${className}`} href={href} {...rest} onClick={handleClick}/>);
};

export default DefaultLink;